import moment from 'moment';

const getDbqAuditMoment = (value) => {
  if (!value) return null;
  const parsed = moment.utc(value);
  return parsed.isValid() ? parsed : null;
};

export const getDbqAuditTimeMs = (value) => getDbqAuditMoment(value)?.valueOf() ?? null;

export const getDbqAuditRelativeTime = (value) =>
  getDbqAuditMoment(value)?.fromNow() ?? 'Unknown time';

export const getDbqAuditLocalDateTime = (value) =>
  getDbqAuditMoment(value)?.local().toDate().toLocaleString() ?? 'Unknown time';
